export default "__VITE_PUBLIC_ASSET__8aca8d9e__"